import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';

import { getNewsDetailRequest, getNewsRequest } from './news.requests';

export const newsInfiniteQueryOptions = () =>
  infiniteQueryOptions({
    queryFn: ({ pageParam }) => getNewsRequest(pageParam),
    getNextPageParam: (lastPage) => lastPage.next_cursor,
    getPreviousPageParam: (firstPage) => firstPage.prev_cursor,
    initialPageParam: '',
    queryKey: ['news'],
  });

export const newsDetailQueryOptions = (newsId: string) =>
  queryOptions({
    queryFn: () => getNewsDetailRequest(newsId),
    queryKey: ['news-detail', { newsId }],
  });
